import React from 'react';
import i18n from 'i18next';

import { addModal, NewItemFormContainer } from '@/exceed';

import getAgendaItemModelDefaults from './getAgendaItemModelDefaults';
import getAxiosConfig from './getAxiosConfig';

import getAgendaItemSchema from '../schemas/getAgendaItemSchema';
import handleAgendaItemDataErrors from './handleAgendaItemDataErrors';

export default (model, { adminSettings, currentUser }) => {
  const id = 'new-agenda-item';

  return addModal({
    component: (
      <NewItemFormContainer
        getAxiosConfig={(data) => getAxiosConfig('create-agenda-item', data)}
        id={id}
        isFullScreen
        schema={getAgendaItemSchema({ adminSettings, isEditMode: false })}
        submitText={i18n.t('create')}
        onDataErrors={handleAgendaItemDataErrors}
      />
    ),
    hasCloseButton: true,
    id,
    isFullScreen: true,
    model: { ...getAgendaItemModelDefaults({ currentUser }), ...model },
    title: i18n.t('create-new-agenda-item'),
  });
};
